import React from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from '@mui/material'
import useIntl from '@/utils/intl'
import { ExpandMore } from '@mui/icons-material'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'

interface Props {
  onBack: () => void
  onContinue: () => void
  status?: string
}

const TermsPage: React.FC<Props> = ({ onBack, onContinue, status }) => {
  const { translate } = useIntl()

  return (
    <div className='flex flex-col h-full w-full bg-surfaceWebGrey'>
      <div className='flex-grow px-4 py-4 sm:px-8 sm:py-8 overflow-y-auto flex flex-col gap-4 w-full max-w-md mx-auto'>
        <div className='bg-surfaceInverse rounded-2xl border border-primary p-2'>
          <Accordion
            className='rounded-lg bg-surfaceWebGrey mb-2'
            elevation={0}
            sx={{ '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore className='text-textMid' />}
              aria-controls='panel1-content'
              id='panel1-header'
            >
              <Typography className='text-textHigh font-semibold text-base'>
                {translate('leasing.info.termsofservice')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className='px-4 pt-1 pb-4'>
              <ul className='list-disc space-y-1 pl-5'>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.termsofservice1')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.termsofservice2')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.termsofservice3')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.termsofservice4')}
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
          <Accordion
            className='rounded-lg bg-surfaceWebGrey mb-2'
            elevation={0}
            sx={{ '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore className='text-textMid' />}
              aria-controls='panel2-content'
              id='panel2-header'
            >
              <Typography className='text-textHigh font-semibold text-base'>
                {translate('leasing.info.consumer')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className='px-4 pt-1 pb-4'>
              <p className='text-textMid text-sm mb-2'>
                {translate('leasing.info.consumer1')}
              </p>
              <ul className='list-disc space-y-1 pl-5'>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.consumer2')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.consumer3')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.consumer4')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.consumer5')}
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
          <Accordion
            className='rounded-lg bg-surfaceWebGrey mb-2'
            elevation={0}
            sx={{ '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore className='text-textMid' />}
              aria-controls='panel3-content'
              id='panel3-header'
            >
              <Typography className='text-textHigh font-semibold text-base'>
                {translate('leasing.info.corporate')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className='px-4 pt-1 pb-4'>
              <p className='text-textMid text-sm mb-2'>
                {translate('leasing.info.corporate1')}
              </p>
              <ul className='list-disc space-y-1 pl-5'>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.corporate2')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.corporate3')}
                </li>
              </ul>
              <p className='text-textMid text-sm mb-2 mt-2'>
                {translate('leasing.info.corporate4')}
              </p>
              <ul className='list-disc space-y-1 pl-5'>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.corporate5')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.corporate6')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.corporate7')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.corporate8')}
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
          <Accordion
            className='rounded-lg bg-surfaceWebGrey'
            elevation={0}
            sx={{ '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore className='text-textMid' />}
              aria-controls='panel4-content'
              id='panel4-header'
            >
              <Typography className='text-textHigh font-semibold text-base'>
                {translate('leasing.info.location')}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className='px-4 pt-1 pb-4'>
              <ul className='list-disc space-y-1 pl-5'>
                <li className='text-textMid text-sm'>
                  {translate('leasing.info.location1')}
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='pb-20 md:pb-0' />
      </div>
      {status === 'PENDING' || status === 'COMPLETE'
        ? (
          <div className='fixed md:sticky bottom-0 rounded-b-xl right-0 left-0 z-50 md:p-6 p-4 border-t bg-surfaceInverse border-secondaryMidStroke'>
            <div className='w-full max-w-md mx-auto flex gap-4'>
              <DarkButton fullwidth size='sm' onClick={onContinue}>
                {translate('continue')}
              </DarkButton>
            </div>
          </div>
          )
        : null}
    </div>
  )
}

export default TermsPage
